var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVan2 = function SvgVan2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.964 7.313l-.875-2.188a1 1 0 00-.928-.625H12V4a.5.5 0 00-.5-.5H2a1 1 0 00-1 1v7a1 1 0 001 1h1.063a2 2 0 003.875 0h3.125a2 2 0 003.874 0H15a1 1 0 001-1v-4a.5.5 0 00-.036-.187M12 5.5h2.161l.6 1.5H12zm-10-1h9v4H2zM5 13a1 1 0 110-2 1 1 0 010 2m5.063-1.5H6.937a2 2 0 00-3.875 0H2v-2h9v.77a2 2 0 00-.937 1.23M12 13a1 1 0 110-2 1 1 0 010 2m3-1.5h-1.062A2.004 2.004 0 0012 10V8h3z"
  })));
};
export default SvgVan2;